import { UPDATED_SAFE_TRADE_STATUS } from './safeTradeActionTypes.js';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATED_SAFE_TRADE_STATUS:
            return {
                ...state,
                viewStatus: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./safeTrade/seller/safeTradeReducer.js